<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AsWqt1/CoverDesign.jpg?1684571217707" alt="This image is the cover for the book Dreams and Expectations, Before… and After"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dreams and Expectations, Before… and After
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Before… and After Story</i></b></p><p>At what point are differences irreparable?</p> <p>Tom McAllister and Nick Corwin have always had a comfortable friendship, even though Nick is a Native American webcomic artist and Tom’s father is a rigid Christian. But they’re about to discover growing up means more challenges than choosing a college major. It might mean making decisions that change pivotal relationships—or sever them.</p> <p>When a bully confronts Tom and Nick and a dark, unsettling aspect of Tom emerges, Nick is shaken enough to end their friendship. As both young men struggle to balance their own dreams with the expectations of their families—both in terms of career and faith—they recognize the emptiness that parting ways has left in their lives. But when reconciliation leads to confessions that might mean something more than friendship between them, will it make their path easier to navigate or more difficult?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Laine
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28d05c86